module.exports = __webpack_public_path__ + "static/img/fwzc_bj.435e7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_bj.png
// module id = xZgL
// module chunks = 2